import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { MatRadioButton } from '@angular/material/radio';
import { Observable } from 'rxjs';
import { map, startWith, tap } from 'rxjs/operators';
import { Autoevaluacion } from '../autoevaluacion';

@Component({
  selector: 'app-autoevaluacion-criterio-button',
  standalone: false,
  templateUrl: './autoevaluacion-criterio-button.component.html',
  styleUrls: ['../../retroalimentacion/retroalimentacion.component.scss', '../autoevaluacion-criterio-group/autoevaluacion-criterio-group.component.scss', './autoevaluacion-criterio-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutoevaluacionCriterioButtonComponent implements OnInit {

  @Input()
  criterioNombre: string;
  @Input()
  radio: MatRadioButton;
  @Input()
  criterioId: number;
  @Input()
  radioForm: UntypedFormGroup;
  @Input()
  label: string;
  @Input()
  criterioEvaluacionId: number;
  @Input()
  imagenAlumno: string;
  @Input()
  imagenProfesor: string;
  @Input()
  alumnoNombre: string;
  @Input()
  profeNombre: string;
  @Input()
  autoevaluacion: Autoevaluacion;
  @Input()
  criterioEscala: string;
  @Input()
  expanded: boolean;

  checked$: Observable<boolean>;

  constructor() { }

  ngOnInit(): void {
    this.checked$ = this.checkedStatusObservable(this.radioForm.valueChanges);
  }

  onClick() {
    if (!this.autoevaluacion.eventoMateriaAlumnoConfig.completoAutoevaluacion) {
      if (this.radio.checked === true) {
        this.radioForm.setValue({radio: null, save: true});
      } else {
        this.radioForm.setValue({radio: this.criterioId, save: true});
      }
    }
  }

  checkedStatusObservable(formControl: Observable<any>) {
    return formControl.pipe(
      map(data => {
        return data.radio === this.criterioId;
      }),
      startWith(this.radio.checked)
    );
  }
}
